export default "__VITE_ASSET__BM0BEiGw__"